import { Button } from '../../../Components/ui/button';
import { Card } from '../../../Components/ui/card';
import { Label } from '../../../Components/ui/label';
import {
  Select,
  SelectItem,
  SelectTrigger,
  SelectContent,
  SelectValue,
} from '../../../Components/ui/select';
import { CircularProgress } from '@mui/material';
import { Input } from '../../../Components/ui/input';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useState, SetStateAction, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';
import { Tabs, TabsContent } from '../../../Components/ui/tabs';
import axios, { AxiosResponse } from 'axios';
import { useToast } from '../../../Components/ui/use-toast';
import { Toaster } from '../../../Components/ui/toaster';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { CalendarIcon } from '@radix-ui/react-icons';
import { addDays, format, startOfMonth } from 'date-fns';
import { DateRange } from 'react-day-picker';
import { Calendar } from '../../../Components/ui/calendar';
import { Switch } from '../../../Components/ui/switch';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../Components/ui/popover';
import { cn } from '../../../lib/utils';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCreateBreadCrumb,
  setTargetCountry,
  setCreateCampaign,
} from '../../../State/slices/AdvertiserAccountSlice';
import { RootState } from '@/src/State/store';
import { FaPaperPlane } from 'react-icons/fa';
import { LuPlane } from 'react-icons/lu';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../../Components/ui/dialog';
import {
  setDraftedCampaign,
  clearDraftedCampaign,
} from '../../../State/slices/CampaignSlice';
import { debug } from 'console';
import CampaignNameCard from './Components/CampaignNameCard';
import SheduleCard from './Components/SheduleCard';
import AdvancedSettingsCard from './Components/AdvancedSettingsCard';
import CampaignChannelsCard from './Components/CampaignChannelsCard';
import AudienceCard from './Components/AudienceCard';
// import CreateContentWhatsapp from "./Components/CreateContentWhatsappCard";
import { CampaignProvider, useCampaignContext } from './CampaignContext';
import { getChannelCounts } from './utils/getChannelCounts';
import { useCampaignValidators } from './hooks/useCampaignValidators';
import { convertCampaignWindowToUTC } from './utils/convertToUTC';
import { DateTime } from 'luxon';
import { revertCampaignWindowFromUTC } from './utils/revertCampaignWindowFromUTC';
import { RowData } from './CampaignContext'; // your types file path
import { setSelectedFromCountryISOs } from '../../../State/slices/AdvertiserAccountSlice';
import { SaveIcon } from 'lucide-react';

// import Audience from "../../Audiences/Audience";

interface AudienceCardProps {
  selectedRecipients: number;
  totalRecipients: number;
}

interface Country {
  country_id: number;
  country_name: string;
}

interface multiselect {
  country_id: string;
}

interface Template {
  template_id: number;
  template_name: string;
  channel_type: string;
}

interface Channel {
  channelId: number;
  channelName: string;
}

interface CheckedChannel {
  channelId: number;
  channelName: string;
}

interface DatePickerWithRangeProps {
  className?: string;
}

interface ApiData {
  status: string;
  status_Description: string;
  totalCount: number;
  audienceCounts: AudienceCount[];
}

interface AudienceCount {
  fromCountry: string;
  toCountry: string;
  totalCount: number;
}

type ShortCodeEntry = {
  smppId: number;
  smsConnectionId: number;
  smsNumber: string;
};

interface BillingCountry {
  workspace_info_id: number;
  workspace_name: string;
  country_id: number;
  country_name: string;
  currency_name: string;
  symbol: string;
}

interface Notification {
  id: number;
  campaignId: number;
  statusMark: string;
  notificationType: string;
  createdAt: string;
  notificationData: {
    Comment?: string;
    [key: string]: string | undefined;
  };
  role: string;
}

export interface WhatsAppBusinessAccount {
  id: string;
  display_phone_number: string;
}

export default function CreateCampaign() {
  const {
    campaignName,
    setCampaignName,
    fromCountries,
    toCountry,
    setFromCountries,
    setToCountry,
    campaignStartDate,
    campaignEndDate,
    setCampaignEndDate,
    setCampaignStartDate,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    campaignDesc,
    allocationType,
    setAllocationType,
    isDuplicatePrevented,
    setIsDuplicatePrevented,
    whatsappData,
    smsData,
    resetCampaign,
    whatsappContent,
    smsContent,
    isPremiumOnly,
    selectedToCountryISO,
    fromCountryISOs,
    setCampaignNameError,
    setFromCountryError,
    setToCountryError,
    setContentError,
    setStartDateError,
    setEndDateError,
    setEndTimeError,
    setStartTimeError,
    setIsSubmitAttempted,
    selectedToCountryCode,
    selectedFromCountryCodes,
    roamingDaysByCountry,
    selectedTimeZone,
    resetWhatsappContent,
    setWhatsappContent,
    resetSMSContent,
    setSmsContent,
    setIsPremiumOnly,
    setSelectedTimeZone,
    timezoneOptions,
    setSelectedFromCountryCodes,
    setBody,
    setLanguage,
    setMediaBase64,
    setHeaderType,
    setSelectedOption,
    setTextInput,
    setBodyText,
    setFooterText,
    setRows,
    setUpdateCampaignId,
    setFromCountryISOsFromAPI,
    setToCountryISOFromAPI,
    setUpdateModeTravellerCount,
    setIsUpdateMode,
    setFileType,
    setFileLength,
    setFileName,
    setPreviewImage,
    setSelectedFile,
    setIsViewMode,
    countValidationAgainstEachCountry,
    hasInsufficientMessages,
    setPartsCount,
    setShowWarning,
    setMediaConfig,
    isLoading,
    setLoading,
    setIsDraftMode,
    isViewMode,
    isUpdateMode,
    setSelectedToCountryISO,
    setDraftNames,
    draftNames,
    setIsDraftSubmitAttempted,
    setDraftId,
    isDraftToBeSavedAutomatically,
    setIsDraftToBeSavedAutomatically,
    selectedCampaign,
    audienceType,
    setAudienceType,
    setSelectedCampaign,
    isTestMode,
    setIsTestMode,
    setRoamingDaysByCountry,
    isTravellerCountExceeded,
  } = useCampaignContext();

  const selectedFromCountryISOs = useSelector(
    (state: RootState) => state.advertiserAccount.selectedFromCountryISOs,
  );

  const {
    validateCampaignName,
    validateFromCountry,
    validateToCountry,
    validateContent,
    validateStartDate,
    validateEndDate,
    validateStartTime,
    validateEndTime,
    validateTimeZone,
    validateContentAlone,
    validateDraftName,
  } = useCampaignValidators();

  const Email = useSelector(
    (state: RootState) => state.authentication.userEmail,
  );
  const [categoryId, setCategoryId] = useState<number>();

  //Create Mode State
  const [isCreateMode, setIsCreateMode] = useState<boolean>(false);

  let listId = '';
  const navigate = useNavigate();
  const location = useLocation();
  const campaignNames = location.state?.campaignNames || [];
  const campaignId = location.state?.campaignId || '';
  const viewModecampaignId = location.state?.viewModecampaignId || '';
  const draft_id = location.state?.draft_id || '';

  const channelName = location.state?.channelType || '';
  // const [apiUrlAdvAcc, setApiUrlAdvAcc] = useState("");
  const dispatch = useDispatch();
  const draftCampaign = useSelector((state: RootState) => state.campaign);
  const toast = useToast();
  const [audience, setAudience] = useState<number>(0);
  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );

  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id,
  );

  const [updateAudience, setUpdateAudience] = useState('');
  const incountry = useSelector(
    (state: RootState) => state.advertiserAccount.incountry,
  );
  const BillingCountrydata = useSelector(
    (state: RootState) => state.authentication.workspaceData?.billingCountry,
  );
  const [shouldFetchRecipients, setShouldFetchRecipients] = useState(false);
  const [dailyRecipientLimit, setDailyRecipientLimit] = useState<number | ''>(
    '',
  );
  const [isFrequencyOpen, setIsFrequencyOpen] = useState(false);
  const [isReceiveLimitOpen, setIsReceiveLimitOpen] = useState(false);
  const [messageFrequencyError, setMessageFrequencyError] = useState<
    string | null
  >(null);
  const [isAdminApproved, setIsAdminApproved] = useState<boolean | null>(null);
  const [isOperatorApproved, setIsOperatorApproved] = useState<boolean | null>(
    null,
  );

  const [tempSelectedCountries, setTempSelectedCountries] = useState<string[]>(
    [],
  );
  const [totalRecepientsdFromAud, setTotalRecepientsFromAud] =
    useState<string>('');
  const [SelectedRecipientsFromAud, setSelectedRecipientsFromAud] =
    useState<number>(0);
  const [totalRecipientsFromOP, setTotalRecipientsByOP] = useState<number>(0); // total recipients count from operator
  const [SelectedRecipientsFromOP, setSelectedRecipientsByOP] =
    useState<number>(0);
  let fromReceipientsCount = 0;
  const [countryBasedRecipients, setCountryBasedRecipients] = useState<
    number | null
  >(null);

  const [selectedcampaignBudget, setSelectedCampaignBudget] =
    useState<number>(0); //Maha
  const [SelectedRecipientsFromBudget, setSelectedRecipientsFromBudget] =
    useState<number>(0);
  const [initialSelectedRecipients] = useState(0);
  const [initialTotalRecipients] = useState(0);

  const [hasUserSelected, setHasUserSelected] = useState(false);
  const [campaignType, setCampaignType] = useState<string>(''); //Needed
  const [isFormValidated, setIsFormValidated] = useState(false);
  const [canSubmit, setCanSubmit] = useState(true);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const whatsappUrl = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );

  const workspaceName = useSelector(
    (state: RootState) => state.authentication.workspaceName,
  );

  const apiUrlAdminAcc = useSelector(
    (state: RootState) => state.authentication.adminUrl,
  );

  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );

  const [audienceApiData, setAudienceApiData] = useState<ApiData | null>(null);
  const [isLoadingAudience, setIsLoadingAudience] = useState(false);

  const isImpersonated = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonationState,
  );
  const impersonatorAID = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonatorAID,
  );

  useEffect(() => {
    if (apiUrlAdvAcc) {
      const fetchData = async () => {
        try {
          await Promise.all([
            //campaignId ? loadCampaignList(campaignId) : Promise.resolve(),
            campaignId ? getAdminComment(campaignId) : Promise.resolve(),
          ]);
        } catch (error) {
          toast.toast({
            title: 'Error',
            description: 'Something went wrong, Please try again later',
          });
        }
      };
      fetchData();
    }
  }, [apiUrlAdvAcc]);

  const [commentDismissed, setCommentDismissed] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [campaignComment, setCampaignComment] = useState<string | null>(null);

  // Function to fetch audience data from your actual API
  const fetchAudienceData = async () => {
    // Only fetch if we have the required data
    if (!selectedFromCountryISOs?.length || !selectedToCountryISO) {
      // Instead of setting null here, just return early
      return;
    }

    try {
      setIsLoadingAudience(true);

      const queryParams = new URLSearchParams();
      selectedFromCountryISOs.forEach((country) => {
        queryParams.append('fromCountries', country);
      });
      queryParams.append('toCountry', selectedToCountryISO);

      const response = await axios.get(
        `${apiUrlAdvAcc}/GetAudienceCount?${queryParams.toString()}`,
      );

      if (response.data && response.data.status === 'Success') {
        const transformedData = {
          status: response.data.status,
          status_Description: response.data.status_Description,
          totalCount: response.data.totalCount,
          audienceCounts: response.data.audienceCounts.map((item: any) => ({
            fromCountry: item.fromCountry,
            toCountry: item.toCountry,
            totalCount: item.totalCount,
          })),
        };
        setAudienceApiData(transformedData);
      } else {
        setAudienceApiData({
          status: 'Success',
          status_Description: '',
          totalCount: 0,
          audienceCounts: [],
        });
      }
    } catch (error) {
      console.error('Error fetching audience data:', error);
      setAudienceApiData({
        status: 'Success',
        status_Description: '',
        totalCount: 0,
        audienceCounts: [],
      });
    } finally {
      setIsLoadingAudience(false);
    }
  };

  const fetchEligibleData = async (
    campaignId: number,
    fromCountries: string[],
    toCountry: string,
  ) => {
    if (!campaignId || !fromCountries.length || !toCountry) return;

    try {
      setIsLoadingAudience(true);

      const params = new URLSearchParams();
      params.append('campaignId', campaignId.toString());

      fromCountries.forEach((country) =>
        params.append('fromCountries', country),
      );

      params.append('toCountry', toCountry);

      const response = await axios.get(
        `${apiUrlAdvAcc}/GetEligibleContactsCount?${params.toString()}`,
      );

      if (response.data.status === 'Success') {
        const normalizedData: ApiData = {
          status: response.data.status,
          status_Description: response.data.status_Description,
          totalCount: response.data.totalCount,
          audienceCounts: response.data.eligibleContacts.map((item: any) => ({
            fromCountry: item.fromCountry,
            toCountry: item.toCountry,
            totalCount: item.contactCount,
          })),
        };

        setAudienceApiData(normalizedData);
      } else {
        setAudienceApiData(null);
      }
    } catch (error) {
      console.error('Error fetching eligible contacts:', error);
      setAudienceApiData(null);
    } finally {
      setIsLoadingAudience(false);
    }
  };

  useEffect(() => {
    console.log('Effect fired', selectedFromCountryISOs);

    if (selectedFromCountryISOs.length === 0) {
      // Only reset if we're sure it's not just a remount
      if (selectedFromCountryISOs !== null) {
        setAudienceApiData(null);
      }
      return;
    }

    fetchAudienceData();
  }, [selectedFromCountryISOs, selectedToCountryISO, apiUrlAdvAcc]);

  useEffect(() => {
    if (
      audienceType === 'Reuse Audience' &&
      selectedCampaign &&
      selectedFromCountryISOs?.length &&
      selectedToCountryISO
    ) {
      fetchEligibleData(
        Number(selectedCampaign),
        selectedFromCountryISOs,
        selectedToCountryISO,
      );
    } else {
      setAudienceApiData(null);
    }
  }, [
    selectedCampaign,
    audienceType,
    selectedFromCountryISOs,
    selectedToCountryISO,
  ]);

  useEffect(() => {
    console.log(
      'hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
      isCreateMode,
    );
  }, [isCreateMode]);

  useEffect(() => {
    if (location.state?.draft_id) {
      setDraftId(Number(location.state.draft_id));
    }
  }, [location.state]);

  const saveCampaignDraft = async (
    workspaceId: number,
    draftData: Record<string, any>,
  ) => {
    setLoading(true);
    try {
      const response = await axios.post(`${apiUrlAdvAcc}/SaveDraft`, {
        workspaceId: workspaceId,
        draftData: draftData,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      });

      if (response.data?.status === 'Success') {
        console.log('Draft saved successfully for workspaceId:', workspaceId);
        setLoading(false);
        toast.toast({
          title: 'Success',
          description: 'Draft saved successfully',
        });
        return true; // Return success status
      } else {
        console.warn(
          'Failed to save draft for workspaceId:',
          workspaceId,
          'Response:',
          response.data,
        );
        setLoading(false);
        toast.toast({
          title: 'Failure',
          description: 'Something went wrong',
        });
        return false; // Return failure status
      }
    } catch (error) {
      console.error('Error saving campaign draft:', error);
      setLoading(false);
      toast.toast({
        title: 'Failure',
        description: 'Something went wrong',
      });
      return false; // Return failure status
    }
  };

  const prevPath = useRef(location.pathname);
  const latestDataRef = useRef<{
    campaignName: string | null;
    selectedFromCountryCodes: string[] | null;
    selectedToCountryCode: string | null;
    campaignStartDate: string | null;
    campaignEndDate: string | null;
    startTime: string | null;
    endTime: string | null;
    selectedTimeZone: any;
    whatsappData: any;
    smsData: any;
    selectedToCountryISO: string | null;
    fromCountryISOs: any;
    whatsappContent: any;
    smsContent: any;
    isPremiumOnly: boolean;
    isDuplicatePrevented: boolean;
    allocationType: string | null;
    // roamingDays: string | number | null;
    accountId: string | number | null;
    workspaceId: number | undefined;
    selectedFromCountryISOs: string[] | null;
    fromCountries: any; // ✅ new
    toCountry: any; // ✅ new
    roamingDaysByCountry: any;
    audienceType: string;
    selectedCampaign: string;
    isTestMode: boolean;
  } | null>(null);

  // Update the ref whenever relevant state changes
  useEffect(() => {
    console.log('📝 REF UPDATE TRIGGERED');
    console.log(
      '📝 selectedFromCountryISOs being saved to ref:',
      selectedFromCountryISOs,
    );
    console.log('📝 fromCountries:', fromCountries);
    console.log('📝 All state values:', {
      campaignName,
      selectedFromCountryCodes,
      selectedToCountryCode,
      selectedFromCountryISOs,
      fromCountries,
      toCountry,
    });

    latestDataRef.current = {
      campaignName,
      selectedFromCountryCodes,
      selectedToCountryCode,
      campaignStartDate,
      campaignEndDate,
      startTime,
      endTime,
      selectedTimeZone,
      whatsappData,
      smsData,
      selectedToCountryISO,
      fromCountryISOs,
      whatsappContent,
      smsContent,
      isPremiumOnly,
      isDuplicatePrevented,
      allocationType,
      accountId,
      workspaceId,
      selectedFromCountryISOs,
      fromCountries, // ✅
      toCountry, // ✅
      roamingDaysByCountry, // ✅ new
      audienceType, // ✅ new
      selectedCampaign, // ✅ new
      isTestMode,
    };

    console.log(
      '📝 REF UPDATED - selectedFromCountryISOs in ref:',
      latestDataRef.current.selectedFromCountryISOs,
    );
    console.log('📝 REF UPDATED - Full ref object:', latestDataRef.current);
  }, [
    campaignName,
    campaignDesc,
    selectedFromCountryCodes,
    selectedToCountryCode,
    campaignStartDate,
    campaignEndDate,
    startTime,
    endTime,
    selectedTimeZone,
    whatsappData,
    smsData,
    selectedToCountryISO,
    fromCountryISOs,
    whatsappContent,
    smsContent,
    isPremiumOnly,
    isDuplicatePrevented,
    allocationType,
    accountId,
    workspaceId,
    categoryId,
    selectedFromCountryISOs,
    fromCountries,
    toCountry,
    roamingDaysByCountry,
    audienceType,
    selectedCampaign,
    isTestMode,
  ]);

  // Add this ref at the top of your component
  const latestModesRef = useRef({ isUpdateMode, isViewMode, isCreateMode });

  // Add this useEffect to keep the ref updated
  useEffect(() => {
    latestModesRef.current = { isUpdateMode, isViewMode, isCreateMode };
  }, [isUpdateMode, isViewMode, isCreateMode]);

  // Handler for same page usage - navigates to campaign list
  const handleCampaignDraftSave = async () => {
    setIsDraftSubmitAttempted(true);

    const isDraftNameValid = validateDraftName(campaignName, draftNames);

    if (!isDraftNameValid) {
      toast.toast({
        title: 'Validation Failed',
        description: 'Please correct the highlighted errors before submitting.',
      });
      return;
    }

    const currentData = latestDataRef.current;
    if (!currentData) {
      console.log('No data to save');
      return;
    }

    const channelCounts = getChannelCounts(
      currentData.whatsappData,
      currentData.smsData,
      currentData.selectedToCountryISO || '',
      currentData.fromCountryISOs || [],
    );

    const templatedetails: any = {};
    if (currentData.whatsappContent)
      templatedetails.whatsappContent = currentData.whatsappContent;
    if (currentData.smsContent)
      templatedetails.smsContent = currentData.smsContent;

    const data = {
      campaigndetails: {
        campaign_name: currentData.campaignName || '',
        from_countries: currentData.selectedFromCountryCodes || [],
        to_country: currentData.selectedToCountryCode || '',
        campaign_start_date: currentData.campaignStartDate,
        campaign_end_date: currentData.campaignEndDate,
        start_time: currentData.startTime,
        end_time: currentData.endTime,
        total_traveller_count: channelCounts,
        is_premium_only: currentData.isPremiumOnly,
        is_duplicate_prevented: currentData.isDuplicatePrevented,
        allocation_type: currentData.allocationType || '',
        // roaming_days: Number(currentData.roamingDays || 0),
        selectedFromCountryISOs: currentData.selectedFromCountryISOs || [],
        selectedToCountryISO: currentData.selectedToCountryISO || '',
        selected_to_country_timezone: currentData.selectedTimeZone?.label ?? '',
        fromCountries: currentData.fromCountries || [],
        toCountry: currentData.toCountry || '',
        roaming_days_by_country: currentData.roamingDaysByCountry || {},
        audience_type: currentData.audienceType || 'None',
        selected_campaign: currentData.selectedCampaign || '',
        is_test_mode: currentData.isTestMode ?? false,
      },
      templatedetails,
    };

    const success = await saveCampaignDraft(currentData.workspaceId || 0, data);

    if (success) {
      resetCampaign();
      resetSMSContent();
      resetWhatsappContent();
      navigate('/navbar/campaignlist');
    }
  };

  // Handler for ScheduleCard usage - navigates to billing
  const handleCampaignDraftSaveForSchedule = async () => {
    setIsDraftSubmitAttempted(true);

    const isDraftNameValid = validateDraftName(campaignName, draftNames);

    if (!isDraftNameValid) {
      toast.toast({
        title: 'Validation Failed',
        description: 'Please correct the highlighted errors before submitting.',
      });
      return;
    }

    const currentData = latestDataRef.current;
    if (!currentData) {
      console.log('No data to save');
      return;
    }

    const channelCounts = getChannelCounts(
      currentData.whatsappData,
      currentData.smsData,
      currentData.selectedToCountryISO || '',
      currentData.fromCountryISOs || [],
    );

    const templatedetails: any = {};
    if (currentData.whatsappContent)
      templatedetails.whatsappContent = currentData.whatsappContent;
    if (currentData.smsContent)
      templatedetails.smsContent = currentData.smsContent;

    const data = {
      campaigndetails: {
        campaign_name: currentData.campaignName || '',
        from_countries: currentData.selectedFromCountryCodes || [],
        to_country: currentData.selectedToCountryCode || '',
        campaign_start_date: currentData.campaignStartDate,
        campaign_end_date: currentData.campaignEndDate,
        start_time: currentData.startTime,
        end_time: currentData.endTime,
        total_traveller_count: channelCounts,
        is_premium_only: currentData.isPremiumOnly,
        is_duplicate_prevented: currentData.isDuplicatePrevented,
        allocation_type: currentData.allocationType || '',
        // roaming_days: Number(currentData.roamingDays || 0),
        selectedFromCountryISOs: currentData.selectedFromCountryISOs || [],
        selectedToCountryISO: currentData.selectedToCountryISO || '',
        selected_to_country_timezone: currentData.selectedTimeZone?.label ?? '',
        fromCountries: currentData.fromCountries || [],
        toCountry: currentData.toCountry || '',
        roaming_days_by_country: currentData.roamingDaysByCountry || {},
        audience_type: currentData.audienceType || 'None',
        selected_campaign: currentData.selectedCampaign || '',
        is_test_mode: currentData.isTestMode ?? false,
      },
      templatedetails,
    };

    const success = await saveCampaignDraft(currentData.workspaceId || 0, data);

    if (success) {
      resetCampaign();
      resetSMSContent();
      resetWhatsappContent();
      navigate('/settings/Billing', {
        state: { route: 'Billing' },
      });
    }
  };

  const GetCampaignDraftNames = async () => {
    try {
      const res = await axios.get(
        `${apiUrlAdvAcc}/GetAllCampaignDraftNamesByWorkspaceId`,
        {
          params: { workspaceId: workspaceId },
        },
      );

      if (res.data.status === 'Success' && Array.isArray(res.data.draftNames)) {
        const names = res.data.draftNames;
        setDraftNames(names.map((name: string) => name.toLowerCase())); // 👈 normalize if needed
      } else {
        setDraftNames([]);
      }
    } catch (err) {
      setDraftNames([]);
    }
  };

  useEffect(() => {
    GetCampaignDraftNames();
  }, []);

  const DeleteCampaignDraftByWorkspaceIdAndDraftId = async (
    workspaceId: number,
    draftId: number,
  ) => {
    try {
      const response = await axios.delete(
        `${apiUrlAdvAcc}/DeleteCampaignDraftByWorkspaceIdAndDraftId?workspaceId=${workspaceId}&draftId=${draftId}`,
      );

      if (response.data?.status === 'Success') {
        console.log(
          `Draft deleted for workspaceId: ${workspaceId}, draftId: ${draftId}, deletedCount: ${response.data.deletedCount}`,
        );
      } else {
        console.warn(
          `Failed to delete draft for workspaceId: ${workspaceId}, draftId: ${draftId}`,
          response.data,
        );
      }
    } catch (error) {
      console.error(
        'Error deleting campaign draft by workspace ID and draft ID:',
        error,
      );
    }
  };

  const GetCampaignByCampaignId = async (campaignId: number) => {
    try {
      const response = await axios.get(
        `${apiUrlAdvAcc}/GetCampaignByCampaignId?campaignId=${campaignId}`,
      );

      if (response.data?.status === 'Success' && response.data?.campaignData) {
        const data = response.data.campaignData;
        console.log(JSON.stringify(data, null, 2));
        setUpdateModeTravellerCount(data.total_traveller_count);
        console.log(
          '✅ Traveller count set:',
          data.total_traveller_count,
          Date.now(),
        );

        // 🔷 Advanced Settings
        // setRoamingDays(data.roaming_age?.toString() || "1");
        setAllocationType(data.allocation_type || 'Life Time Allocation');
        setIsDuplicatePrevented(data.duplicate_msg ?? true);
        setIsPremiumOnly(data.premium_number ?? false);

        // 🔷 Campaign Name
        setCampaignName(data.campaign_name || '');

        // Clean timezone string (remove offset)
        const cleanedTimezone =
          data.selected_to_country_timezone?.split(' ')?.[0] || 'UTC';

        // 🔷 Convert UTC to Local
        const { localStartDate, localStartTime, localEndDate, localEndTime } =
          revertCampaignWindowFromUTC(
            data.start_date,
            data.start_time,
            data.end_date,
            data.end_time,
            cleanedTimezone,
          );

        setCampaignStartDate(localStartDate);
        setStartTime(localStartTime);
        setCampaignEndDate(localEndDate);
        setEndTime(localEndTime);

        if (data.selected_to_country_timezone) {
          setSelectedTimeZone({
            label: data.selected_to_country_timezone,
            value: data.selected_to_country_timezone,
          });
        } else {
          setSelectedTimeZone(null); // Optional: reset if not available
        }

        // // 🔷 From Country (set ISO and Code separately)
        // // setSelectedFromCountryISOs(data.from_country_iso || []);

        // dispatch(setSelectedFromCountryISOs(data.from_country_iso || []));
        // console.log("set", selectedFromCountryISOs);
        // setSelectedFromCountryCodes(data.from_country || []);

        // 🔷 Roaming Days — set BEFORE dispatching ISOs to prevent useEffect overwriting with defaults
        if (data.roaming_age && typeof data.roaming_age === 'object') {
          const roamingDays: Record<string, any> = {};
          Object.entries(data.roaming_age).forEach(
            ([iso, value]: [string, any]) => {
              roamingDays[iso.toLowerCase()] = value;
            },
          );
          setRoamingDaysByCountry(roamingDays);
        }

        // 🔷 From Country (set ISO and Code separately)
        // setSelectedFromCountryISOs(data.from_country_iso || []);

        dispatch(setSelectedFromCountryISOs(data.from_country_iso || []));
        console.log('set', selectedFromCountryISOs);
        setSelectedFromCountryCodes(data.from_country || []);

        // ✅ Helper function to convert base64 to real File object
        const base64ToFile = (
          base64String: string,
          fileName: string,
          fileType: string,
        ): File => {
          // Remove data:type;base64, prefix if present
          const base64Data = base64String.includes(',')
            ? base64String.split(',')[1]
            : base64String;

          // Convert base64 to binary
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: fileType });

          // Create actual File object
          return new File([blob], fileName, { type: fileType });
        };

        const templates = data.templates || [];

        // 🔹 Find templates by channel_id
        const whatsappTemplate = templates.find((t: any) => t.channel_id === 1);
        const smsTemplate = templates.find((t: any) => t.channel_id === 2);

        // 🔹 Extract WhatsApp Template (Updated Structure)
        if (whatsappTemplate?.template_content?.template_content) {
          const outerContent = whatsappTemplate.template_content;
          const content = outerContent.template_content;

          console.log('📱 WhatsApp Template Found:', { outerContent, content });

          // ✅ Set complete WhatsApp content structure (like SMS)
          const completeWhatsappTemplate = {
            template: {
              channel_id: outerContent.channel_id || 1,
              channel_type: outerContent.channel_type || 'Whatsapp',
              part_count: outerContent.part_count || 1,
              campaign_name: outerContent.campaign_name || campaignName,
              media_config: {
                file_name: outerContent.media_config?.file_name || '',
                file_type: outerContent.media_config?.file_type || '',
                binary_data: outerContent.media_config?.binary_data || '',
                file_length: outerContent.media_config?.file_length || '',
              },
              template_content: {
                name: content.name || '',
                category: content.category || '',
                language: content.language || '',
                components: JSON.stringify(content.components || []), // ✅ Stringify only components
              },
              ...(outerContent.QR?.length > 0 && { QR: outerContent.QR }),
            },
          };

          // ✅ Set complete WhatsApp content to context
          setWhatsappContent(completeWhatsappTemplate);

          // ✅ Set individual media config states (empty strings from API)
          setMediaBase64(outerContent.media_config?.binary_data || '');
          setFileName(outerContent.media_config?.file_name || '');
          setFileLength(outerContent.media_config?.file_length || '');
          setFileType(outerContent.media_config?.file_type || '');

          // ✅ Set combined media config state (NEW)
          setMediaConfig({
            file_name: outerContent.media_config?.file_name || '',
            file_type: outerContent.media_config?.file_type || '',
            binary_data: outerContent.media_config?.binary_data || '',
            file_length: outerContent.media_config?.file_length || '',
          });

          // ✅ Set language
          setLanguage(content.language || '');

          // 🔹 Extract components safely
          const components = content.components || [];

          // 🔸 HEADER
          const headerComponent = components.find(
            (comp: any) => comp.type === 'HEADER',
          );
          if (headerComponent && headerComponent.format) {
            const apiFormat = headerComponent.format;

            switch (apiFormat.toUpperCase()) {
              case 'TEXT':
                setHeaderType('text');
                setSelectedOption('text');
                setTextInput(headerComponent.text || '');
                break;

              case 'IMAGE':
                setHeaderType('image');
                setSelectedOption('image');
                // Handle image media - check if binary_data exists and is not empty
                if (
                  outerContent.media_config?.binary_data &&
                  outerContent.media_config.binary_data.trim() !== ''
                ) {
                  setPreviewImage(outerContent.media_config.binary_data);

                  // ✅ Create real File object for image
                  const realImageFile = base64ToFile(
                    outerContent.media_config.binary_data,
                    outerContent.media_config.file_name,
                    outerContent.media_config.file_type,
                  );
                  setSelectedFile(realImageFile);
                }
                break;

              case 'VIDEO':
                setHeaderType('video');
                setSelectedOption('video');
                // Handle video media - check if binary_data exists and is not empty
                if (
                  outerContent.media_config?.binary_data &&
                  outerContent.media_config.binary_data.trim() !== ''
                ) {
                  // ✅ Create real File object for video
                  const realVideoFile = base64ToFile(
                    outerContent.media_config.binary_data,
                    outerContent.media_config.file_name,
                    outerContent.media_config.file_type,
                  );
                  setSelectedFile(realVideoFile);
                }
                break;

              case 'DOCUMENT':
                setHeaderType('document');
                setSelectedOption('document');
                // Handle document media - check if binary_data exists and is not empty
                if (
                  outerContent.media_config?.binary_data &&
                  outerContent.media_config.binary_data.trim() !== ''
                ) {
                  // ✅ Create real File object for document
                  const realDocFile = base64ToFile(
                    outerContent.media_config.binary_data,
                    outerContent.media_config.file_name,
                    outerContent.media_config.file_type,
                  );
                  setSelectedFile(realDocFile);
                }
                break;

              default:
                setHeaderType('none');
                setSelectedOption('none');
            }
          } else {
            setHeaderType('none');
            setSelectedOption('none');
          }

          // 🔸 BODY
          const bodyComponent = components.find(
            (comp: any) => comp.type === 'BODY',
          );
          if (bodyComponent) {
            setBodyText(bodyComponent.text || '');
          }

          // 🔸 FOOTER
          const footerComponent = components.find(
            (comp: any) => comp.type === 'FOOTER',
          );
          if (footerComponent) {
            setFooterText(footerComponent.text || '');
          }

          const buttonComponent = components.find(
            (comp: any) => comp.type === 'BUTTONS',
          );
          if (buttonComponent?.buttons?.length > 0) {
            const qrArray = outerContent.QR || [];

            const transformedRows: RowData[] = buttonComponent.buttons.map(
              (btn: any) => {
                if (btn.type === 'URL') {
                  return {
                    buttonType: 'URL',
                    buttonText: btn.text,
                    buttonTypeDropdown: 'static',
                    websiteUrl: btn.url,
                    callPhoneNumber: '',
                    countryCode: '',
                    copyOfferCode: '',
                    quickReplyResponse: '',
                    optOut: false,
                  };
                } else if (btn.type === 'PHONE_NUMBER') {
                  const phone = btn.phone_number || '';
                  const phoneStr = phone.toString();
                  const countryCode =
                    phoneStr.length > 10 ? phoneStr.slice(0, -10) : '';
                  const phoneNumber =
                    phoneStr.length > 10 ? phoneStr.slice(-10) : phoneStr;

                  return {
                    buttonType: 'PHONE_NUMBER',
                    buttonText: btn.text,
                    buttonTypeDropdown: 'static',
                    callPhoneNumber: phoneNumber,
                    countryCode: countryCode,
                    websiteUrl: '',
                    copyOfferCode: '',
                    quickReplyResponse: '',
                    optOut: false,
                  };
                } else if (btn.type === 'COPY_CODE') {
                  return {
                    buttonType: 'COPY_CODE',
                    buttonText: 'Copy',
                    buttonTypeDropdown: 'static',
                    websiteUrl: '',
                    callPhoneNumber: '',
                    countryCode: '',
                    copyOfferCode: btn.example || '',
                    quickReplyResponse: '',
                    optOut: false,
                  };
                } else if (btn.type === 'QUICK_REPLY') {
                  const qrEntry = qrArray.find(
                    (qr: any) => qr.label === btn.text,
                  ); // ✅ label-based matching

                  return {
                    buttonType: 'QUICK_REPLY',
                    buttonText: btn.text,
                    buttonTypeDropdown: 'static',
                    websiteUrl: '',
                    callPhoneNumber: '',
                    countryCode: '',
                    copyOfferCode: '',
                    quickReplyResponse: qrEntry?.response || '',
                    optOut: qrEntry?.opt_out ?? false,
                  };
                }

                return {
                  buttonType: '',
                  buttonText: '',
                  buttonTypeDropdown: 'static',
                  websiteUrl: '',
                  callPhoneNumber: '',
                  countryCode: '',
                  copyOfferCode: '',
                  quickReplyResponse: '',
                  optOut: false,
                };
              },
            );

            setRows(transformedRows);
          } else {
            setRows([]);
          }

          console.log('✅ WhatsApp Content loaded:', {
            completeTemplate: completeWhatsappTemplate,
            mediaConfig: outerContent.media_config,
            components: components.length,
          });
        } else {
          console.warn('⚠️ WhatsApp template not found or malformed');
          // ✅ Reset WhatsApp states if no template found
          setWhatsappContent(null);
          setMediaConfig({
            file_name: '',
            file_type: '',
            binary_data: '',
            file_length: '',
          });
          setMediaBase64('');
          setFileName('');
          setFileLength('');
          setFileType('');
        }

        // 🔹 Extract SMS Template
        if (smsTemplate?.template_content?.template_content) {
          const outerContent = smsTemplate.template_content;
          const smsContent = outerContent.template_content;

          console.log('📱 SMS Template Found:', smsContent);

          // ✅ Set SMS message body (the main content)
          setBody(smsContent.message || '');

          // ✅ Set parts count from API
          setPartsCount(outerContent.part_count || 1);

          // ✅ Set warning if parts > 1
          setShowWarning(outerContent.part_count > 1);

          // ✅ Reconstruct complete SMS template structure for context
          const completeSmsTemplate = {
            template: {
              channel_id: outerContent.channel_id || 2,
              channel_type: outerContent.channel_type || 'SMS',
              part_count: outerContent.part_count || 1,
              campaign_name: outerContent.campaign_name || campaignName,
              template_content: {
                name: smsContent.name || '',
                message: smsContent.message || '',
              },
            },
          };

          // ✅ Set complete SMS content to context
          setSmsContent(completeSmsTemplate);

          console.log('✅ SMS Content loaded:', {
            message: smsContent.message,
            partsCount: outerContent.part_count,
            completeTemplate: completeSmsTemplate,
          });
        } else {
          console.warn('⚠️ SMS template not found or malformed');
          // ✅ Reset SMS states if no template found
          setBody('');
          setPartsCount(1);
          setShowWarning(false);
          setSmsContent(null);
        }

        setFromCountryISOsFromAPI(data.from_country_iso);
        setToCountryISOFromAPI(data.to_country_iso);
        setSelectedToCountryISO(data.to_country_iso);
        setUpdateModeTravellerCount(data.total_traveller_count);
        setIsTestMode(data.status === 'sandbox');

        // Parse audience_config JSON
        let parsedAudienceConfig: any = null;
        if (data.audience_config) {
          try {
            parsedAudienceConfig =
              typeof data.audience_config === 'string'
                ? JSON.parse(data.audience_config)
                : data.audience_config;
          } catch (error) {
            console.error('Error parsing audience_config:', error);
          }
        }

        // Set audience type and selected campaign
        if (parsedAudienceConfig) {
          setAudienceType(parsedAudienceConfig.type || '');
          if (
            parsedAudienceConfig.type === 'Reuse Audience' &&
            parsedAudienceConfig.campaign_id
          ) {
            setSelectedCampaign(parsedAudienceConfig.campaign_id || '');
          } else {
            setSelectedCampaign('');
          }
        } else {
          setAudienceType('');
          setSelectedCampaign('');
        }

        console.log('✅ Audience Config loaded:', {
          audienceType: parsedAudienceConfig?.type,
          selectedCampaign: parsedAudienceConfig?.campaign_id,
          linkedCampaignName: data.linked_campaign_name,
        });
      } else {
        console.warn('Invalid response or campaign data missing');
        return null;
      }
    } catch (error) {
      console.error('Error fetching campaign by ID:', error);
      return null;
    }
  };

  useEffect(() => {
    if (campaignId) {
      setIsViewMode(false);
      setUpdateCampaignId(campaignId);
      setIsUpdateMode(true);
      console.log('updateMOde');
      setTimeout(() => {
        GetCampaignByCampaignId(campaignId);
      }, 100); // ✅ same pattern as viewMode
    }
  }, [campaignId]);

  useEffect(() => {
    console.log('set', selectedFromCountryISOs);
  }, [selectedFromCountryISOs]);

  useEffect(() => {
    if (viewModecampaignId) {
      setIsViewMode(true);
      setIsUpdateMode(true);
      setUpdateCampaignId(viewModecampaignId);
      console.log(
        'ViewMOdeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
      );
      setTimeout(() => {
        GetCampaignByCampaignId(viewModecampaignId);
      }, 100);
    }
  }, [viewModecampaignId]);

  const getWorkspaceCategoryByWorkspaceID = async () => {
    try {
      if (!workspaceId) {
        console.warn('No workspaceId found');
        return null;
      }

      const response = await axios.get(
        `${apiUrlAdvAcc}/GetWorkspaceCategoryByWorkspaceID`,
        {
          params: {
            workspaceId: workspaceId,
          },
        },
      );

      if (response.data && response.data.status === 'Success') {
        const workspaceCategory = response.data.workspaceIndustry;
        setCategoryId(workspaceCategory);
        console.log('Workspace Industry ID:', workspaceCategory);

        return workspaceCategory;
      } else {
        console.warn(
          'No industry found:',
          response.data?.status_Description ?? 'Unknown error',
        );
        return null;
      }
    } catch (error) {
      console.error('Error fetching workspace category:', error);
      return null;
    }
  };

  useEffect(() => {
    getWorkspaceCategoryByWorkspaceID();
  }, []);

  const handleDiscard = () => {
    setIsViewMode(false);
    resetCampaign();
    resetWhatsappContent();
    resetSMSContent();
    dispatch(clearDraftedCampaign());
    sessionStorage.removeItem('draftedCampaign');
    dispatch(setCreateBreadCrumb(false));
    navigate('/navbar/campaignlist');
    setTimeout(() => {
      // DeleteCampaignDraftByWorkspaceId();
    }, 1000);
    setIsDraftMode(true);
  };

  //useEffect for capturing campaignname change after whatsapp content payload constrution
  useEffect(() => {
    if (!whatsappContent) return;

    const updatedWhatsappContent = {
      ...whatsappContent,
      template: {
        ...whatsappContent.template,
        campaign_name: campaignName,
        template_content: {
          ...whatsappContent.template.template_content,
          name: `${campaignName.toLowerCase().replace(/\s+/g, '')}_whatsapp_${workspaceId}`,
        },
      },
    };

    setWhatsappContent(updatedWhatsappContent);
  }, [campaignName]);

  //useEffect for capturing campaignname change after sms content payload constrution
  useEffect(() => {
    if (!smsContent?.template) return;

    setSmsContent((prev: any) => {
      return {
        ...prev,
        template: {
          ...prev.template,
          campaign_name: campaignName,
          template_content: {
            ...prev.template.template_content,
            name: `${campaignName.toLowerCase().replace(/\s+/g, '')}_sms_${workspaceId}`,
          },
        },
      };
    });
  }, [campaignName]);

  const handleUpdateCampaign = async () => {
    console.log('🧪 selectedTimeZone VALUE:', selectedTimeZone?.value);

    //New Validation Callings
    const isContentValid = validateContentAlone(whatsappContent, smsContent);
    const isStartDateValid = validateStartDate(campaignStartDate);
    const isEndDateValid = validateEndDate(campaignEndDate);
    const isValidStartTime = validateStartTime(startTime);
    const isValidEndTime = validateEndTime(endTime);

    const isFormValid =
      isContentValid &&
      isStartDateValid &&
      isEndDateValid &&
      isValidStartTime &&
      isValidEndTime;
    if (!isFormValid) {
      setCanSubmit(false);
      toast.toast({
        title: 'Validation Failed',
        description: 'Please correct the highlighted errors before submitting.',
      });
      return;
    }

    const cleanTimeZone = selectedTimeZone?.value.split(' (')[0] ?? ''; // → "Africa/Algiers"
    const roamingDaysPayload = formatRoamingDaysPayload(roamingDaysByCountry);

    const { utcStartDate, utcStartTime, utcEndDate, utcEndTime } =
      convertCampaignWindowToUTC(
        campaignStartDate,
        campaignEndDate,
        startTime,
        endTime,
        cleanTimeZone,
      );

    const templatedetails: any = {};
    if (whatsappContent) templatedetails.whatsappContent = whatsappContent;
    if (smsContent) templatedetails.smsContent = smsContent;
    const Updatedata = {
      campaigndetails: {
        campaign_start_date: utcStartDate,
        campaign_end_date: utcEndDate,
        start_time: utcStartTime,
        end_time: utcEndTime,
        is_premium_only: isPremiumOnly,
        is_duplicate_prevented: isDuplicatePrevented,
        allocation_type: allocationType,
        // roaming_days: Number(roamingDays),
        roaming_days: roamingDaysPayload,
        user_account_id: accountId,
        advertiser_workspace_id: workspaceId,
        status: isTestMode ? 'sandbox' : 'active',
        created_time: new Date().toISOString(),
        last_updated_time: new Date().toISOString(),
        admin_approval: 'pending',
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
        audience_config: {
          type: audienceType,
          campaign_id:
            audienceType === 'Reuse Audience' ? selectedCampaign : null,
        },
      },
      templatedetails,
    };

    console.log(
      '✅ whatsappContent before update:',
      JSON.stringify(whatsappContent, null, 2),
    );
    // console.log("✅ FINAL PAYLOAD:", JSON.stringify(Updatedata, null, 2));
    try {
      debugger;
      setLoading(true);
      const response = await axios.put(
        `${apiUrlAdvAcc}/UpdateCampaign?campaignId=${campaignId}`,
        Updatedata,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.data.status === 'Success') {
        await triggerCampaignCreationWebhookn8n(campaignId, false);
        await sendNotificationforresubmission(
          campaignId,
          campaignName,
          'created',
        );
        try {
          const auditPayload = {
            user_account_id: accountId,
            campaign_id: campaignId,
            advertiser_workspace_id: workspaceId,
            campaign_status: isTestMode ? 'sandbox' : 'active',
          };
          const auditResponse = await axios.post(
            `${apiUrlAdvAcc}/UpdateCampaignDetailsInsertAuditHistroy`,
            null, // No body, since it's query parameters
            {
              params: auditPayload,
            },
          );
          console.log('✅ Audit History Inserted:', auditResponse.data);
        } catch (auditErr) {
          console.error('❌ Audit History Insert Failed', auditErr);
        }
        setLoading(false);
        toast.toast({
          title: 'Success.',
          description: 'Campaign Updated Successfully.',
        });

        resetCampaign();
        resetWhatsappContent();
        resetSMSContent();
        navigate('/navbar/campaignlist');
        // Delay of 1 second (1000 milliseconds)
      } else {
        setLoading(false);
        toast.toast({
          title: 'Error',
          description: 'Something went wrong. Please try again later.',
        });
      }
    } catch (error: any) {
      setLoading(false);
      toast.toast({
        title: 'Error',
        description: 'Something went wrong. Please try again later.',
      });
    }
  };
  const getAdminComment = async (campaignId: number) => {
    try {
      const response = await axios.get(
        `${apiUrlAdvAcc}/GetCampaignNotifications?workspaceId=${workspaceId}`,
      );

      const campaignNotifications: Notification[] = response.data.notifications
        .filter((n: any) => n.role?.toLowerCase() === 'advertiser')
        .map((campaign: any) => {
          const rawData = campaign.notificationData || {};
          const normalizedData: Record<string, string> = {};
          Object.keys(rawData).forEach((key) => {
            const trimmedKey = key.trim();
            normalizedData[trimmedKey] = rawData[key];
          });

          return {
            id: campaign.id,
            campaignId: campaign.campaignId,
            statusMark: campaign.statusMark,
            notificationType: campaign.notificationType,
            createdAt: campaign.createdAt,
            notificationData: normalizedData,
            role: campaign.role,
          };
        });

      const matched = campaignNotifications.find(
        (n) => n.campaignId === campaignId && n.notificationData?.Comment,
      );

      setCampaignComment(matched?.notificationData?.Comment ?? null);
    } catch (error) {}
  };

  const sendNotificationforresubmission = async (
    campaignId: number,
    campaignName: string,
    campaignType: string,
  ) => {
    try {
      debugger;
      const payload = {
        workspaceId: workspaceId,
        campaignId: campaignId,
        campaignName: campaignName,
        statusMark: 'Unread',
        notificationType: 'Campaignresubmitted',
        notificationData: {
          Message: `${workspaceName} resubmitted a campaign - (${campaignName})`,
        },
        role: 'Admin',
      };

      const response = await axios.post(
        `${apiUrlAdvAcc}/CreateNotification`,
        payload,
      );

      if (response.data.status === 'Success') {
      }
    } catch (e) {
    } finally {
      try {
        // const emailResponse = await axios.post(
        //   '${apiUrlAdvAcc}/SendEmailForOperatorCampaign',
        //   null, // No request body
        //   {
        //     params: {
        //       campaignId: campaignId,
        //     },
        //   }
        // );
      } catch (emailErr) {}
    }
  };

  const sendNotification = async (
    campaignId: number,
    campaignName: string,
    campaignType: string,
  ) => {
    try {
      debugger;
      const payload = {
        workspaceId: workspaceId,
        campaignId: campaignId,
        campaignName: campaignName,
        statusMark: 'Unread',
        notificationType: 'CampaignCreated',
        notificationData: {
          Message: `${workspaceName} created a campaign - (${campaignName})`,
        },
        role: 'Admin',
      };

      const response = await axios.post(
        `${apiUrlAdvAcc}/CreateNotification`,
        payload,
      );

      if (response.data.status === 'Success') {
      }
    } catch (e) {
    } finally {
      try {
        // const emailResponse = await axios.post(
        //   '${apiUrlAdvAcc}/SendEmailForOperatorCampaign',
        //   null, // No request body
        //   {
        //     params: {
        //       campaignId: campaignId,
        //     },
        //   }
        // );
      } catch (emailErr) {}
    }
  };

  const triggerCampaignCreationWebhookn8n = async (
    campaignId: any,
    isCreation: boolean,
  ) => {
    try {
      const payload = {
        campaignID: campaignId,
        campaignName: campaignName,
        advertiserID: String(accountId),
        advertiserName: '',
        workspaceID: workspaceId,
        workspaceName: workspaceName,
        request_type: isCreation
          ? 'adv_create_campaign'
          : 'adv_update_campaign',
        advertiser_email: Email,
      };

      const response = await axios.post(
        `${apiUrlAdvAcc}/N8NAdvCampaignCreationandUpdationWebhook`,
        payload,
      );
      if (response.status !== 200) {
        console.error('❌ Webhook Trigger Failed');
      } else {
        console.log('✅ Webhook Triggered Successfully');
      }
    } catch (error) {
      console.error('❗ Error in triggerN8NWebhook', error);
    }
  };
  //For Content Validation based on input traveller count
  const channelCounts = getChannelCounts(
    whatsappData,
    smsData,
    selectedToCountryISO,
    fromCountryISOs,
  );

  //useEffect for calling Content Validation
  useEffect(() => {
    validateContent(whatsappContent, smsContent, channelCounts);
  }, [whatsappContent, smsContent, channelCounts]);

  // Helper function to format roaming days for payload
  const formatRoamingDaysPayload = (roamingDaysByCountry: {
    [iso: string]: {
      condition_a: { con_operator: string; value: number };
      condition_b: { con_operator: string; value: number } | null;
    };
  }) => {
    const payload: any = {};

    Object.keys(roamingDaysByCountry).forEach((iso) => {
      const config = roamingDaysByCountry[iso];

      payload[iso.toLowerCase()] = {
        condition_a: {
          con_operator: config.condition_a.con_operator,
          value: config.condition_a.value,
        },
      };

      // Only include condition_b if it exists
      if (config.condition_b) {
        payload[iso.toLowerCase()].condition_b = {
          con_operator: config.condition_b.con_operator,
          value: config.condition_b.value,
        };
      }
    });

    return payload;
  };

  const handleCreateCampaign = async () => {
    setIsCreateMode(true);
    const { utcStartDate, utcStartTime, utcEndDate, utcEndTime } =
      convertCampaignWindowToUTC(
        campaignStartDate, // "17/07/2025"
        campaignEndDate, // "20/07/2025"
        startTime, // "11:00"
        endTime, // "17:00"
        selectedTimeZone?.value ?? '', // "Asia/Kolkata" (or similar) — safely extract the value
      );

    //For Future reference
    //  "selected_time_zone": {
    //     "label": "Europe/London (UTC+00:00)",
    //     "value": "Europe/London"
    //   }

    const channelCounts = getChannelCounts(
      whatsappData,
      smsData,
      selectedToCountryISO,
      fromCountryISOs,
    );

    const roamingDaysPayload = formatRoamingDaysPayload(roamingDaysByCountry);

    //New Validation Callings
    const isCampaignNameValid = validateCampaignName(campaignName);
    debugger;
    const isFromCountryValid = validateFromCountry(fromCountries);
    const isToCountryValid = validateToCountry(toCountry);
    const isContentValid = validateContent(
      whatsappContent,
      smsContent,
      channelCounts,
    );
    const isStartDateValid = validateStartDate(campaignStartDate);
    const isEndDateValid = validateEndDate(campaignEndDate);
    const isValidStartTime = validateStartTime(startTime);
    const isValidEndTime = validateEndTime(endTime);
    const isValidTimeZone = validateTimeZone(selectedTimeZone?.value ?? ''); // Extracts "Asia/Kolkata" or empty if not selected
    const hasCountryCountErrors =
      Object.values(countValidationAgainstEachCountry.whatsapp).some(
        (msg) => msg,
      ) ||
      Object.values(countValidationAgainstEachCountry.sms).some((msg) => msg);

    const isAudienceValid =
      audienceType !== 'Reuse Audience' || selectedCampaign !== '';

    const isFormValid =
      isCampaignNameValid &&
      isFromCountryValid &&
      isToCountryValid &&
      isContentValid &&
      isStartDateValid &&
      isEndDateValid &&
      isValidStartTime &&
      isValidEndTime &&
      isValidTimeZone &&
      !hasCountryCountErrors && // ✅ Only valid if there are NO errors
      isAudienceValid &&
      !isTravellerCountExceeded;
    if (!isFormValid) {
      setCanSubmit(false);
      toast.toast({
        title: 'Validation Failed',
        description: 'Please correct the highlighted errors before submitting.',
      });
      return;
    }

    const templatedetails: any = {};
    if (whatsappContent) templatedetails.whatsappContent = whatsappContent;
    if (smsContent) templatedetails.smsContent = smsContent;

    const data = {
      campaigndetails: {
        campaign_name: campaignName,
        campaign_desc: campaignDesc,
        from_countries: selectedFromCountryCodes,
        to_country: Number(selectedToCountryCode),
        campaign_start_date: utcStartDate,
        campaign_end_date: utcEndDate,
        start_time: utcStartTime,
        end_time: utcEndTime,
        total_traveller_count: channelCounts,
        is_premium_only: isPremiumOnly,
        is_duplicate_prevented: isDuplicatePrevented,
        allocation_type: allocationType,
        roaming_days: roamingDaysPayload,
        user_account_id: accountId,
        advertiser_workspace_id: workspaceId,
        category_id: categoryId,
        category_sub_id: 1,
        status: isTestMode ? 'sandbox' : 'active',
        created_time: new Date().toISOString(),
        last_updated_time: new Date().toISOString(),
        selectedFromCountryISOs: selectedFromCountryISOs,
        selectedToCountryISO: selectedToCountryISO,
        admin_approval: 'pending',
        selected_to_country_timezone: selectedTimeZone?.label ?? '',
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
        audience_config: {
          type: audienceType,
          campaign_id:
            audienceType === 'Reuse Audience' ? selectedCampaign : null,
        },
      },
      templatedetails,
    };

    console.log('✅ FINAL PAYLOAD:', JSON.stringify(data, null, 2));

    try {
      setLoading(true);
      const response = await axios.post(
        `${apiUrlAdvAcc}/CreateCampaign`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      if (response.data.status === 'Success') {
        setIsCreateMode(true);
        const campaingId = response.data.campaign_id;
        await triggerCampaignCreationWebhookn8n(campaingId, true);
        await sendNotification(campaingId, campaignName, 'created');
        if (draft_id) {
          await DeleteCampaignDraftByWorkspaceIdAndDraftId(
            workspaceId,
            draft_id,
          );
        }
        toast.toast({
          title: 'Success.',
          description: 'Campaign Created Successfully.',
        });
        navigate('/navbar/campaignlist');
        resetCampaign();
        resetWhatsappContent();
        resetSMSContent();

        // Delay of 1 second (1000 milliseconds)
        setLoading(false);
      } else {
        setLoading(false);
        toast.toast({
          title: 'Error',
          description: 'Something went wrong. Please try again later.',
        });
      }
    } catch (error: any) {
      setLoading(false);
      toast.toast({
        title: 'Error',
        description: 'Something went wrong. Please try again later.',
      });
    }
  };

  return (
    <>
      <div className='overflow-y-auto ml-[-7px]'>
        <Toaster />
        {isLoading ? (
          <div className='flex flex-col items-center justify-center h-[500px]'>
            <CircularProgress color='primary' />
          </div>
        ) : (
          <>
            <div className='fixed flex justify-end gap-4 mr-[40px] items-end right-[0px] top-[-15px] z-20 '>
              {/* {((whatsappContent && whatsappData) || (smsContent && smsData)) && <Button className="w-auto bg-[#3A85F7] border text-white hover:"   onClick={handleCampaignDraftSave}>
                <SaveIcon style={{ width: "18px", height: "18px" }}
                  className="mr-2 text-white"
                  />
                Save as Draft
              </Button>} */}

              {!draft_id && !isUpdateMode && !isViewMode && (
                <Button
                  className='w-auto bg-[#3A85F7] border text-white hover:'
                  onClick={handleCampaignDraftSave}
                  disabled={
                    !(
                      whatsappData.some((item) => Number(item.count) > 0) ||
                      smsData.some((item) => Number(item.count) > 0)
                    )
                  }
                >
                  <SaveIcon
                    style={{ width: '18px', height: '18px' }}
                    className='mr-2 text-white'
                  />
                  Save as Draft
                </Button>
              )}

              <Dialog>
                <DialogTrigger asChild>
                  {!isViewMode && (
                    <Button
                      variant='outline'
                      className='w-[80px] border-red-500 text-red-500 hover:bg-red-500 hover:text-white'
                    >
                      Discard
                    </Button>
                  )}
                </DialogTrigger>
                <DialogContent className='sm:max-w-[425px]'>
                  <DialogHeader>
                    <DialogDescription>
                      Are you sure you want to discard this campaign?
                    </DialogDescription>
                  </DialogHeader>
                  <DialogFooter>
                    <DialogClose asChild>
                      <Button type='button' variant='outline' className='w-24'>
                        Cancel
                      </Button>
                    </DialogClose>

                    <Button
                      className='w-24'
                      onClick={() => {
                        // Update the ref immediately before calling handleDiscard
                        latestModesRef.current = {
                          isUpdateMode,
                          isViewMode,
                          isCreateMode: true, // ← Set create mode to true in ref
                        };
                        setIsCreateMode(true);
                        handleDiscard();
                      }}
                      autoFocus
                    >
                      OK
                    </Button>
                  </DialogFooter>
                </DialogContent>
              </Dialog>
              {!isViewMode && (
                <Button
                  className='w-[80px] text-[#F8FAFC]'
                  disabled={hasInsufficientMessages}
                  onClick={() => {
                    if (campaignId) {
                      setIsSubmitAttempted(true);
                      handleUpdateCampaign();
                    } else {
                      setIsCreateMode(true);
                      setIsSubmitAttempted(true);
                      handleCreateCampaign();
                    }
                  }}
                >
                  {campaignId ? 'Update' : 'Submit'}
                </Button>
              )}

              {isViewMode && (
                <Button
                  className='w-[80px] text-[#F8FAFC]'
                  onClick={() => {
                    resetCampaign();
                    resetSMSContent();
                    resetWhatsappContent();
                    navigate('/navbar/campaignlist');
                  }}
                >
                  Back
                </Button>
              )}
            </div>
            <div className='gap-4 flex '>
              <div className='ml-4'>
                <div className='flex mt-2 max-w-[600px] mb-2'>
                  {campaignComment && !commentDismissed && (
                    <div className='flex bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 px-3 py-1.5 text-xs rounded shadow-md w-auto text-center'>
                      ⚠️ {campaignComment}
                      <button
                        onClick={() => setCommentDismissed(true)}
                        className='absolute top-0.5 right-2 text-yellow-700 hover:text-yellow-900 text-xs'
                      >
                        ×
                      </button>
                    </div>
                  )}
                </div>
                <div className='flex gap-4'>
                  {/* Left side - Main campaign cards */}
                  <div className='flex-1 min-w-0'>
                    <CampaignNameCard />
                    <CampaignChannelsCard />
                    <SheduleCard
                      onSaveDraft={handleCampaignDraftSaveForSchedule}
                    />
                    <AdvancedSettingsCard />
                  </div>

                  {/* Right side - Audience card */}
                  <div className='shrink-0'>
                    <div className='fixed w-[400px]  top-[10]'>
                      <AudienceCard
                        apiData={audienceApiData}
                        isLoading={isLoadingAudience}
                        audienceType={audienceType}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
